;
/*!
 * subitotexto.masonryinit.js
 * Initiateur de Masonry
 */


SubitoTexto.masonryInit = {
	init             : function () {
		var $ = jqPla,
			_this = SubitoTexto.masonryInit;

		_this.$allMasonryContainers = $( '.masonry-me' );

		if ( _this.$allMasonryContainers.length < 1 || PLA.UTILS.areWeMobile() ) {
			return;
		}


		_this.$allMasonryContainers.each( function ( el, i ) {
			_this.checkForImages( $( this ) );
		} );


	},
	checkForImages   : function ( $container ) {
		var $ = jqPla,
			_this = SubitoTexto.masonryInit;

		var $images = $container.find( 'img' );

		if ( $images.length > 0 ) {
			// Contains images, so we'll use imagesLoaded

			if ( $container.find( '.pc-group' ).length > 0 ) {


			} else {
				$container.imagesLoaded( function () {
					_this.setupMasonry( $container );
				} );
			}

		} else {
			// no images, this is the size it's going to be

			_this.setupMasonry( $container );
		}
	},
	setupMasonry     : function ( $container ) {
		var $ = jqPla,
			_this = SubitoTexto.masonryInit;

		setTimeout( function () {

			$container.masonry( {
				// // set itemSelector so .grid-sizer is not used in layout
				// itemSelector: '.grid-item',
				// // use element for option
				// columnWidth: '.grid-sizer',
				// percentPosition: true
			} );
		}, 150 );
	},
	adjustAfterResize: function () {
		var $ = jqPla,
			_this = SubitoTexto.masonryInit;

		_this.$allMasonryContainers.each( function ( el, i ) {

			if ( PLA.UTILS.areWeMobile() ) {
				// Disable masonry on mobile if it was previously set up
				_this.$allMasonryContainers.each( function ( el, i ) {
					if ( $( this ).masonry() ) {
						$( this ).masonry( 'destroy' )
					}
				} );
			} else {
				// If we're going from mobile (no masonry) to desktop, let's activate it

				_this.$allMasonryContainers.each( function ( el, i ) {
					if ( !$( this ).masonry() ) {
						_this.checkForImages( $( this ) );
					}


					// ELSE : nothing to do because Masonry will resize itself
				} );
			}
		} );


	}


};

